/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * office毎の週次レポート
 * @export
 * @interface WeeklyReportsOfficeRequest
 */
export interface WeeklyReportsOfficeRequest {
    /**
     * 営業所ID
     * @type {number}
     * @memberof WeeklyReportsOfficeRequest
     */
    officeId?: number;
    /**
     * multiple営業所で検索のためのリスト
     * @type {Array<number>}
     * @memberof WeeklyReportsOfficeRequest
     */
    officeIds?: Array<number>;
    /**
     * week
     * @type {number}
     * @memberof WeeklyReportsOfficeRequest
     */
    weekNo?: number;
    /**
     * year
     * @type {number}
     * @memberof WeeklyReportsOfficeRequest
     */
    year?: number;
}

export function WeeklyReportsOfficeRequestFromJSON(json: any): WeeklyReportsOfficeRequest {
    return WeeklyReportsOfficeRequestFromJSONTyped(json, false);
}

export function WeeklyReportsOfficeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeeklyReportsOfficeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeIds': !exists(json, 'office_ids') ? undefined : json['office_ids'],
        'weekNo': !exists(json, 'week_no') ? undefined : json['week_no'],
        'year': !exists(json, 'year') ? undefined : json['year'],
    };
}

export function WeeklyReportsOfficeRequestToJSON(value?: WeeklyReportsOfficeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'office_ids': value.officeIds,
        'week_no': value.weekNo,
        'year': value.year,
    };
}


